import React from 'react';
import { Table } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface ReportIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const ReportIcon: React.FC<ReportIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <Table size={size} color={color} />
        </IconWrapper>
    );
};
